function getElemAll(element) {
  return document.querySelectorAll(element);
}

function getElem(element) {
  return document.querySelector(element);
}
